const BaseService = require('@/services/BaseService')

const namespace = 'linked-in'

const insights = (options, cb, errorCb) => {
  BaseService.get(`${namespace}/insights`, options, cb, errorCb)
}

const currency = (cb, errorCb) => {
  BaseService.get(`${namespace}/currency`, {}, cb, errorCb)
}

const campaignGroups = (options, cb, errorCb) => {
	BaseService.get(`${namespace}/campaign-groups`, options, cb, errorCb)
}

const campaigns = (options, cb, errorCb) => {
  BaseService.get(`${namespace}/campaigns`, options, cb, errorCb)
}

const ads = (options, cb, errorCb) => {
  BaseService.get(`${namespace}/ads`, options, cb, errorCb)
}

export default {
  insights,
  currency,
  campaignGroups,
  campaigns,
  ads
}
